import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { EventLog } from '../../entities/EventLog/EventLog'
import { LegacyEventLog } from '../../entities/EventLog/LegacyEventLog'

export type EventLogsState = AsyncReduxState<{
    eventLogs: EventLog[] | LegacyEventLog[];
    eventLogsByEntity: EventLog[];
}>;

const initialState: EventLogsState = {
    ...initialAsyncReduxState,
    eventLogs: [],
    eventLogsByEntity: [],
}

export const EventLogsSlice = createSlice({
    name: 'eventLogsReducer',
    initialState,
    reducers: {
        reset(): EventLogsState {
            return {
                ...initialState,
            }
        },
        setIsLoading(state, action: PayloadAction<boolean>): EventLogsState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): EventLogsState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setEventLogs(state, action: PayloadAction<EventLog[] | LegacyEventLog[]>): EventLogsState {
            return {
                ...state,
                eventLogs: action.payload,
            }
        },
        setEventLogsByEntity(state, action: PayloadAction<EventLog[]>): EventLogsState {
            return {
                ...state,
                eventLogsByEntity: action.payload,
            }
        },
    },
})

export const {
    reset,
    setIsLoading,
    setError,
    setEventLogs,
    setEventLogsByEntity,
} = EventLogsSlice.actions

export default EventLogsSlice.reducer
